import { Component, ElementRef, ViewChild, ChangeDetectionStrategy, inject, input } from "@angular/core";

import * as Enums from "../domain/enums";

import {
  DonationAmount,
  IInHonorBindingModel,
  IGiftNotificationBindingModel,
  IDonorTransactionBindingModel,
  ICampaignBindingModel,
  IInHonorNotificationBindingModel,
  IAddressDataBinding,
  IPersonalStoryBidningModel,
  IPlannedGivingContactModel,
} from "../domain/types";
import { DonorBindingModel } from "../domain/models";
import {
  TransactionTypeEnum,
  ChargeFrequencyEnum,
  CreditCardTypeEnum,
} from "../domain/enums";
import { CommonService } from "../common/common.service";
import { DataService } from "../services/data.service";
import { EventBusService, EventsEnum } from "../common/event-bus.service";
import { ConfigService } from "../services/config.service";
import { CsrService } from "../services/csr.service";
import { DonorService } from "../services/donor.service";
import { DonationFrequencyService } from "../services/donation-frequency.service";
import { DonorTransactionBindingModel } from "../domain/models";
import { LanguageService } from "../common/language.service";
import { LoggerService } from "../common/logger.service";
import { PaymentDetailsComponent } from "../payment-details/payment-details.component";
import { HonorComponent } from "../honor/honor.component";
import { Router, ActivatedRoute } from "@angular/router";
import { FormControl, NgForm } from "@angular/forms";
import { catchError, map, switchMap } from "rxjs/operators";
import { combineLatest, Observable, of } from "rxjs";
import { GoogleAnalyticsService } from "../services/google-analytics.service";
import { LocalStorageService } from "../common/local-storage.service";
import { BaseComponent } from "../base.component";
import { RecaptchaV2Component } from "../common/recaptcha-v2/recaptcha-v2.component";
import { PersonalStoryComponent } from "./personal-story.component";
import { validateNoCreditCard } from "../services/no-credit-card.validator";
import { CmnButtonComponent } from "../shared/components/cmn-button/cmn-button.component";
import { CmnIconName } from "../shared/components/cmn-icon/cmn-icon.component";
import {
  BraintreePayloadType,
  DirectPaymentMethod,
  isPaymentCancellation,
} from "../domain/payment.constants";
import {
  BankAccountDetails,
  BankAccountType,
  BankOwnershipType,
} from "../services/echeck-sdk.service";
import { PaymentTokenPayload } from "../services/payment-sdk.service";

@Component({
    selector: "app-donate",
    templateUrl: "./donate.component.html",
    styleUrls: ["./donate.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DonateComponent extends BaseComponent {
  private _common = inject(CommonService);
  private _data = inject(DataService);
  private _eventBus = inject(EventBusService);
  private _config = inject(ConfigService);
  private _donationFrequency = inject(DonationFrequencyService);
  private _language = inject(LanguageService);
  private _logger = inject(LoggerService);
  private _googleAnalytics = inject(GoogleAnalyticsService);
  private _route = inject(ActivatedRoute);
  private _localStorageService = inject(LocalStorageService);
  csr = inject(CsrService);
  donorEditCommon = inject(DonorService);
  router = inject(Router);
  private elementRef = inject(ElementRef);

  readonly CmnIconName = CmnIconName;

  private _currentDonorId: number = -1;

  donate: DonationAmount = "Other";
  language = "en-US";
  gettingCampaign;
  donationAmounts;
  donation;
  private _enableDonation = true;
  dedicateMyGift = false;
  accountNameChanged = false;
  showVerifyModal = false;
  showVerifyCCModal = false;
  showVerifyeCheckPaymentModal = false;
  showConfirmCreditCardECheckPaymentModal = false;
  showFailedCCECheckModal = false;
  honorModel = {} as IInHonorBindingModel;
  giftNotify = {} as IGiftNotificationBindingModel;
  plannedGiving: IPlannedGivingContactModel = {
    plannedGivingInterest: false,
    plannedGivingPhone: "",
    plannedGivingEmail: "",
    useDonorContact: false,
  };
  transaction: IDonorTransactionBindingModel =
    new DonorTransactionBindingModel();
  imageUrl: string = "";
  selectedRecord: string = "";
  item: IDonorTransactionBindingModel;
  typeOut: string;
  frequency: string;
  isVerifying = false;
  showVerifyAddressModal: boolean;
  campaignId: number;
  transactionComplete: boolean;
  recaptchaSiteKey = this._config.recaptchaSiteKey;
  private _waitingForRecaptcha = false;
  personalStoryValidationError: string | null = null;
  additionalCommentsValidationError: string | null = null;

  drtv = input(false);

  @ViewChild("completeGiftBtn") saveDonor: CmnButtonComponent;
  @ViewChild('honorForm', { read: ElementRef }) honorFormRef: ElementRef;
  @ViewChild('donorForm', { read: ElementRef }) donorFormRef: ElementRef;
  @ViewChild('paymentDetailsForm', { read: ElementRef }) paymentDetailsFormRef: ElementRef;
  @ViewChild('giftAmount', { read: ElementRef }) giftAmountRef: ElementRef;
  @ViewChild(PaymentDetailsComponent) paymentDetails: PaymentDetailsComponent;
  @ViewChild(HonorComponent) honorDetails: HonorComponent;
  @ViewChild(PersonalStoryComponent) personalStoryComponent: PersonalStoryComponent;
  @ViewChild("donateForm") donateForm: NgForm;
  nameOnCard = "";
  defaultDonationAmount: number;
  isCCFormReady = false;
  @ViewChild('captchaRef') captchaRef: RecaptchaV2Component;

  constructor() {
    super();
    
    // Get the feature flag first
    this._data.isCampaignLegacyUrlEnabled().subscribe({
      next: (allowLegacy: boolean) => {
        this.csr.allowLegacyUrlFormat = allowLegacy;
        this._getCampaign();

        const campaignId = this.csr.campaignId();
        const donationAmount = this.csr.donationAmount;
    
        if (!this.csr || !campaignId) {
          this._logger.logError({ message: "No campaign Id" });
          this._common.$location.path("/").replace();
        }
    
        const newDonor = new DonorBindingModel();
        newDonor.hospitalId = this.csr.hospitalId();
        newDonor.campaignId = campaignId;
        newDonor.languageValue = this._language.language;
    
        this.language = this._language.language;
    
        this.honorModel.campaignId = campaignId;
        this.giftNotify.campaignId = campaignId;
    
        this.transaction.expirationMonth = 1;
        this.transaction.expirationYear = new Date().getFullYear();
        if (donationAmount !== 0) {
          this.transaction.donationAmount = donationAmount;
        }
    
        this.donorEditCommon.donor = newDonor;
      },
      error: () => {
        this._common.toast.error(this._language.translate("ERROR_LOAD_DONATION_FORM"));
        // Default to false if API call fails
        this.csr.allowLegacyUrlFormat = false;
        this._getCampaign();
      }
    });

    this.toggleCardName();

    this.addSubscription(
      this._eventBus.on(EventsEnum.LanguageChanged).subscribe(() => {
        this.donorEditCommon.donor.languageValue = this._language.language;
      })
    );
  }

  get enableDonation(): boolean {
    return this._enableDonation;
  }

  set enableDonation(value: boolean) {
    this._enableDonation = value;
    this.csr.donationEnabled.set(value);
  }

  protected _afterComponentInit(): void {
    this.addSubscription(
      this._common.showConfirmCreditCardECheckPaymentModal$.subscribe(
        (value) => {
          this.showConfirmCreditCardECheckPaymentModal = value;
        }
      )
    );
  }

  protected _afterComponentDestroy(): void {
    this._waitingForRecaptcha = false;
    this.showConfirmCreditCardECheckPaymentModal = false;
  }

  get notifySomeone() {
    return this.honorDetails?.notifySomeone || false;
  }

  get inMemoryHonorOf() {
    return this.honorDetails?.inMemoryHonorOf || false;
  }

  get paymentType() {
    return this.paymentDetails?.transactionType();
  }

  get isEcheckSelected(): boolean {
    return this.paymentDetails?.isEcheckSelected() || false;
  }

  get accountDisplayName(): string {
    const name = this.transaction.accountPersonName || "";
    return this.transaction.venmoUserName
      ? `${name} (${this.transaction.venmoUserName})`
      : name;
  }

  get isFormValid() {
    this.honorDetails?.touchPlannedGivingIfInvalid();

    if (this.paymentDetails?.selectedDirectMethod() === DirectPaymentMethod.Card) {
      this.paymentDetails.markCardFieldsVisited();
    }

    if (this.hasFormErrors) {
      if (this.isEcheckSelected) {
        this.paymentDetails.markEcheckFieldsTouched();
      }

      this.scrollIntoView();
      return false;
    }

    return true;
  }

  private get hasFormErrors(): boolean {
    return this.donateForm.invalid || this.paymentDetails.hasErrors || this.honorDetails.hasErrors;
  }

  scrollIntoView(): void {
    let elementRef = this.elementRefName;

    if (elementRef) {
      elementRef.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: "start",
        inline: "nearest",
      });
    }
  }

  get elementRefName(): ElementRef | undefined {
    let elementRef;
    if (this.donateForm.invalid) {
      elementRef = this.verifyInvalidFields();
    } else if (this.paymentDetails.hasErrors) {
      elementRef = this.paymentDetailsFormRef;
    } else if (this.honorDetails.hasErrors) {
      elementRef = this.honorFormRef;
    } else if (this.transaction.donationAmount <= 0) {
      elementRef = this.giftAmountRef;
    }
    return elementRef;
  }

  verifyInvalidFields(): ElementRef {
    if (this.donateForm.form.get('bankName') && this.donateForm.form.get('bankName').status == "INVALID" ||
      this.donateForm.form.get('bankNumber') && this.donateForm.form.get('bankNumber').status == "INVALID" ||
      this.donateForm.form.get('routerNumber') && this.donateForm.form.get('routerNumber').status == "INVALID") {
      return this.paymentDetailsFormRef;
    } else {
      return this.donorFormRef;
    }
  }

  onNameChange() {
    if (this.paymentDetails.accountNameChanged()) {
      if ((this.transaction.accountPersonName || "").trim() !== "") {
        return;
      }
    }

    const donor = this.donorEditCommon.donor;
    const firstName = (donor.firstName || "").trim();
    const lastName = (donor.lastName || "").trim();
    const companyName = (donor.companyName || "").trim();

    let derivedName = "";
    if (firstName && lastName) {
      derivedName = `${firstName} ${lastName}`;
    } else if (companyName) {
      derivedName = companyName;
    }

    if (!derivedName) {
      return;
    }

    this.nameOnCard = derivedName;
    this.transaction.accountPersonName = derivedName;
    this.paymentDetails.accountNameChanged.set(false);
  }

  rowClass(value1, value2) {
    if (value1 === undefined || value1 === "") {
      value1 = null;
    }
    if (value2 === undefined || value2 === "") {
      value2 = null;
    }
    if (value1 !== value2) {
      return "differentAddressElement";
    }
    return "";
  }

  wf1MaskAccount(value) {
    if (!value) {
      return "";
    }
    if (value.length > 4) {
      return "*" + value.substring(value.length - 4, value.length);
    }
    return "*" + value;
  }

  handleCloseEditCityModal() {
    const record: IAddressDataBinding = this.donorEditCommon.cities.find(
      (c) => `${c.recordId}` === `${this.selectedRecord}`
    );

    if (!record) return;

    this.donorEditCommon.donor.city = record.city;
    this.donorEditCommon.donor.stateId = record.stateId;
    this.donorEditCommon.donor.stateAbrev = record.stateAbrev;

    this.donorEditCommon.cities.splice(0, this.donorEditCommon.cities.length);
  }

  handleCloseVerifyModal(confirmed: boolean) {
    this.showVerifyModal = false;
    this.showVerifyCCModal = false;
    if (confirmed) {
      if (!this._validateNoCreditCardFieldsForSubmit()) {
        return;
      }
      this._sendTransaction();
    }
  }

  handleOpenVerifyModal() {
    this.showVerifyModal = true;
    this.showVerifyCCModal = this.transaction.transactionType === TransactionTypeEnum.CreditCard;
  }

  handleCloseCreditCardECheckPaymentModal() {
    this.showConfirmCreditCardECheckPaymentModal = false;
    this.continueWithCall(false);
  }

  handleOpenCreditCardECheckPaymentModal() {
    this.showConfirmCreditCardECheckPaymentModal = true;
  }

  handleCloseVerifyeCheckPaymentModal(confirmed = false) {
    this.showVerifyeCheckPaymentModal = false;
    if (confirmed) {
      this._sendECheckTransaction();
    }
  }

  handleOpenVerifyeCheckPaymentModal() {
    this.showVerifyeCheckPaymentModal = true;
  }

  handleCloseFailedCCECheckModal() {
    this.showFailedCCECheckModal = false;
  }

  handleOpenFailedCCECheckModal() {
    this.showFailedCCECheckModal = true;
  }

  handleCloseVerifyAddressModal(reason) {
    this.showVerifyAddressModal = false;
    const state = reason !== '' ? reason : 'closed';
    this.trackModalEvent(state, `user ${state} the modal`);

    // Retrying abandons the verify run, so the submit button has to come back.
    if (reason !== "ignore" && reason !== "accept") {
      this.isVerifying = false;
      return;
    }

    if (reason === "ignore") {
      // user chose to ignore the suggested address - don't save any address verification info
      this.donorEditCommon.donor.addressVerificationDate = null;
      this.donorEditCommon.donor.addressVerificationKey = null;
      this.doSaveDonor();
      return;
    }
    if (reason === "accept") {
      this.donorEditCommon.donor.address1 =
        this.donorEditCommon.melissaData.address1;
      this.donorEditCommon.donor.address2 =
        this.donorEditCommon.melissaData.address2 || "";
      this.donorEditCommon.donor.city = this.donorEditCommon.melissaData.city;
      this.donorEditCommon.donor.state = this.donorEditCommon.melissaData.state;
      this.donorEditCommon.donor.stateId =
        this.donorEditCommon.melissaData.stateId;
      this.donorEditCommon.donor.postalCode =
        this.donorEditCommon.melissaData.postalCode;
      this.donorEditCommon.donor.addressVerificationDate = this.donorEditCommon.melissaData.addressVerificationDate;
      this.donorEditCommon.donor.addressVerificationKey = this.donorEditCommon.melissaData.addressVerificationKey;
      this.doSaveDonor();
      return;
    }
  }

  handleOpenVerifyAddressModal() {
    this.showVerifyAddressModal = true;
  }

  handleChargeFrequencyToggle() {
    this.transaction.chargeFrequency =
      this.transaction.chargeFrequency === ChargeFrequencyEnum.Monthly
        ? ChargeFrequencyEnum.OneTime
        : ChargeFrequencyEnum.Monthly;
  }

  handleAnonymousToggle() {
    this.transaction.displayInDash = !this.transaction.displayInDash;
  }

  private _getCampaign() {
    this.gettingCampaign = true;

    return this._route.paramMap
      .pipe(
        switchMap((paramsMap) => {
          const campaignId = paramsMap.get("cid");
          let hospitalId = paramsMap.get("hid");

          if (campaignId) {
            try {
              const processedCampaignId = this.csr.validateId(campaignId, "campaign ID");
              this.csr.setCampaignId(processedCampaignId);
              this._localStorageService.set("lastCampaignId", processedCampaignId);
              
              if (!hospitalId || hospitalId === "0") {
                hospitalId = "0";
              }
              
              const processedHospitalId = this.csr.validateId(hospitalId, "hospital ID");
              this.csr.setHospitalId(processedHospitalId);
              this._localStorageService.set("lastHospitalId", processedHospitalId);
              this.csr.initialize();
            } catch (e) {
              this.enableDonation = false;
              this.gettingCampaign = false;
              console.error(e);
              this._common.toast.error(this._language.translate("ERROR_INVALID_DONATION_LINK"));
              return of(null);
            }
          }

          // Check if campaign data is already available in signals
          const existingCampaign = this.csr.campaign();
          if (existingCampaign) {
            return of(existingCampaign);
          }

          return this._data.getCampaignForCsr(this.csr.campaignId());
        })
      )
      .subscribe({
        next: (result) => {
          const campaign = <ICampaignBindingModel>result;
          this.csr.campaign.set(campaign);
          this.language = campaign.languageValue;
          this._eventBus.emit({
            name: EventsEnum.LanguageChanged,
            data: campaign.languageValue,
          });

          //check if the campaign image url is already set in the csr service
          if(this.csr.campaignImageUrl()) 
            this.imageUrl = this.csr.campaignImageUrl();
          else
            this.imageUrl = `${this._common.serviceUrl(this._config.apiServices.campaign)}SplashImage/${this.csr.campaignId()}`;

          this.donationAmounts = [campaign.donationAmount];
          this["donate"] = campaign.donationAmount;
          this.defaultDonationAmount = campaign.donationAmount;
          const otherAmts = (campaign.additionalSuggestedAmounts || "").split(
            ","
          );

          //Set initial value
          this.transaction.donationAmount = campaign.donationAmount || 0;

          if (this.drtv()) {
            this.transaction.chargeFrequency = ChargeFrequencyEnum.Monthly;
          }

          otherAmts.forEach((amt, i) => {
            let v = parseFloat(amt || "");
            if (v && this.donationAmounts.indexOf(v) === -1) {
              this.donationAmounts.push(v);
            }
          });

          const obsList: Observable<any>[] = [];

          // Check if hospital data is already available in the csr service
          const existingHospital = this.csr.hospital();
          if (existingHospital) {
            this.csr.setHospitalName(existingHospital.hospitalName);
          } else if (this.csr.hospitalId() && this.csr.hospitalId() !== "0") {
            obsList.push(this._getHospital());
          }
          
          // Check if radio station data is already available in the csr service
          const existingRadioStation = this.csr.radioStation();
          if (!existingRadioStation && this.csr.radioStationId() && this.csr.radioStationId() !== "0") {
            obsList.push(this._getRadioStation());
          }
          
          if (obsList.length > 0) {
            combineLatest(obsList).subscribe({
              next: (rtn) => {
                this.enableDonation = true;
                this.gettingCampaign = false;
              },
              error: (error) => {
                this.enableDonation = false;
                this.gettingCampaign = false;
              }
            });
          } else {
            this.enableDonation = true;
            this.gettingCampaign = false;
          }
        },
        error: (error) => {
          this._logger.logError({
            message: `Could not get the Campaign<br />${this._common.jsonMessage(
              error
            )}`,
          });
          this.enableDonation = false;
          this.gettingCampaign = false;
        }
      });
  }

  private _getHospital() {
    return this._data.getHospital(this.csr.hospitalId()).pipe(
      map((hospital) => {
        this.csr.setHospitalName(hospital.hospitalName);
        this.csr.hospital.set(hospital); // Store in signal for future use
        return hospital;
      }),
      catchError((error) => {
        const htmlMessage = this._common.jsonMessage(error);
        this._logger.logError({
          message: `Could not get the Hospital<br />${htmlMessage}`,
        });
        this.enableDonation = false;
        throw error;
      })
    );
  }

  private _getRadioStation() {
    return this._data.getRadioStation(this.csr.radioStationId()).pipe(
      map((radioStation) => {
        this.csr.radioStation.set(radioStation); // Store in signal for future use
        return radioStation;
      }),
      catchError((error) => {
        const htmlMessage = this._common.jsonMessage(error);
        this._logger.logError({
          message: `Could not get the Radio Station<br /> ${htmlMessage}`,
        });
        this.enableDonation = false;
        throw error;
      })
    );
  }

  dedicateMyGiftClicked() {
    if (!this.dedicateMyGift) {
      this.dedicateMyGift = false;
    } else {
      this.dedicateMyGift = true;
    }
  }

  amountListClicked() {}

  toggleCardName() {
    if (!this.transaction || this.accountNameChanged) {
      return;
    }

    const donor = this.donorEditCommon.donor;
    const firstName = (donor.firstName || "").trim();
    const lastName = (donor.lastName || "").trim();
    const companyName = (donor.companyName || "").trim();

    if (firstName && lastName) {
      this.transaction.accountPersonName = `${firstName} ${lastName}`;
    } else if (companyName) {
      this.transaction.accountPersonName = companyName;
    }
  }

  toggleSpinner(show = false) {
    this._eventBus.emit({ name: EventsEnum.SpinnerToggle, data: show });
  }

  save() {
    this.donorEditCommon.inHonorRequested(false);

    if (this.isVerifying) {
      return;
    }

    if (!this.isFormValid) {
      this._common.toast.warning(
        this._language.translate("VALIDATION_REQUIRED_FIELDS")
      );
      return;
    }

    if (this.transaction.donationAmount <= 0) {
      this.scrollIntoView();
      this._common.toast.warning(this._language.translate("VALIDATION_DONATION_AMOUNT"));
      return;
    }

    if (!this.paymentDetails?.selected()) {
      this.scrollIntoView();
      this._common.toast.warning(
        this._language.translate("PAYMENT_METHOD_REQUIRED")
      );
      return;
    }

    this.isVerifying = true;

    // Yield a macrotask so the busy state paints before tokenization blocks.
    setTimeout(() => this._verify(), 0);
  }

  private _verify(): void {
    if (this._currentDonorId !== -1) {
      this._continueAfterDonor();
      return;
    }

    this.toggleSpinner(true);
    this.donorEditCommon.verifyAddress().subscribe({
      next: (retVal) => {
        this.donorEditCommon.melissaData.addressVerificationKey = retVal.addressKey;
        this.donorEditCommon.melissaData.addressVerificationDate = retVal.validatedDateTime;
        if (!retVal.validAddress) {
          this.donorEditCommon.melissaData.address1 = retVal.address1;
          this.donorEditCommon.melissaData.address2 =
            retVal.address2 === "" ? null : retVal.address2;
          this.donorEditCommon.melissaData.city = retVal.city;
          this.donorEditCommon.melissaData.state = retVal.state;
          this.donorEditCommon.melissaData.stateId = retVal.stateId;
          this.donorEditCommon.melissaData.postalCode = retVal.postalCode;

          this.toggleSpinner(false);
          this.handleOpenVerifyAddressModal();
        } else {
          this.doSaveDonor();
        }
      },
      error: (error) => {
        this.toggleSpinner(false);
        this.isVerifying = false;
        this._logger.logError({
          message: `Could not verify the address<br />${this._common.jsonMessage(
            error
          )}`,
        });
      },
    });
  }

  doSaveDonor() {
    if (this._waitingForRecaptcha) {
      return;
    }

    // Get a fresh token after address confirmation, immediately before saving.
    this.isVerifying = true;
    this._waitingForRecaptcha = true;
    this.toggleSpinner(false);
    this.captchaRef.execute();
  }

  private _saveDonor(captchaToken: string): void {
    this._applyPlannedGivingToDonor();
    this.donorEditCommon.saveDonor(captchaToken).subscribe({
      next: (retVal) => {
        if (!retVal) {
          this.isVerifying = false;
          this.toggleSpinner(false);
          return;
        }
        this._currentDonorId = retVal.donorId;
        this.csr.donorId = retVal.donorId;
        this.csr.donorSeed = retVal.donorSeed;
        this.csr.donorFirstName = retVal.firstName;
        this.csr.donorLastName = retVal.lastName;
        this.csr.setHospitalId(retVal.hospitalId);

        this._continueAfterDonor();
      },
      error: (error) => {
        this.isVerifying = false;
        this._logger.logError({
          message: `Error saving donor: ${error}`,
        });
        this.toggleSpinner(false);
      }
    });
  }

  private _continueAfterDonor(): void {
    if (this.isEcheckSelected) {
      this.submitECheck();
      this.isVerifying = false;
      return;
    }

    this.processPayment();
  }

  async processPayment(): Promise<void> {
    this.toggleSpinner(true);

    try {
      const payload = await this.paymentDetails.preparePayment(
        this.transaction.donationAmount
      );
      this.submitPayment(payload);
    } catch (error) {
      this._handlePaymentError(error);
    } finally {
      this.toggleSpinner(false);
      this.isVerifying = false;
    }
  }

  private _handlePaymentError(error: unknown): void {
    if (isPaymentCancellation(error)) {
      return;
    }

    console.error(error);
    this._common.toast.error(
      this._language.translate("PAYMENT_METHOD_VERIFY"),
      this._language.translate("PAYMENT_METHOD_HEADING")
    );
  }


  submitPayment(payload: PaymentTokenPayload) {
    switch (payload.type) {
      case BraintreePayloadType.CreditCard:
        this.transaction.transactionType = TransactionTypeEnum.CreditCard;
        break;
      case BraintreePayloadType.PayPalAccount:
        this.transaction.transactionType = TransactionTypeEnum.PayPal;
        break;
      case BraintreePayloadType.VenmoAccount:
        this.transaction.transactionType = TransactionTypeEnum.Venmo;
        break;
      case BraintreePayloadType.ApplePayCard:
        this.transaction.transactionType = TransactionTypeEnum.ApplePay;
        break;
      default:
        this._common.toast.error(
          this._language.translate("PAYMENT_METHOD_UNSUPPORTED")
        );
        return;
    }

    if (this.transaction.transactionType === TransactionTypeEnum.CreditCard) {
      const details = payload.details as {
        lastFour: string;
        expirationMonth: string;
        expirationYear: string;
        cardholderName: string;
        cardType: string;
      };
      this.transaction.creditCard = details.lastFour;
      this.transaction.expirationMonth = parseInt(details.expirationMonth);
      this.transaction.expirationYear = parseInt(details.expirationYear);
      this.transaction.accountPersonName = details.cardholderName;
      this.typeOut = details.cardType;
      this.transaction.creditCardType = this._mapCreditCardType(details.cardType);
    }

    if (this.transaction.transactionType === TransactionTypeEnum.Venmo) {
      const donor = this.donorEditCommon.donor;
      this.transaction.accountPersonName = `${(donor.firstName || "").trim()} ${(
        donor.lastName || ""
      ).trim()}`.trim();
      const venmoDetails = payload.details as { username?: string };
      this.transaction.venmoUserName = venmoDetails?.username || "";
    }

    this.transaction.deviceData = this.paymentDetails.getDeviceData();

    this.transaction.donorId = this.csr.donorId;
    this.transaction.campaignId = this.csr.campaignId();
    this.transaction.hospitalId = this.csr.hospitalId();
    this.transaction.radioStationNameId = this.csr.radioStationId();
    this.transaction.phoneDonationYn = false;
    this.transaction.donationSourceId = 3;
    this.transaction.donorSeed = this.csr.donorSeed;
    this.transaction.donorReferenceNumber = this.csr.donorReferenceNumber;

    this.transaction.cmnhHospitalId = this.donorEditCommon.donor.cmnhHospitalId;

    if (this.transaction.chargeFrequency !== ChargeFrequencyEnum.OneTime) {
      this.transaction.dayToCharge = this._donationFrequency.dayOfMonth;
      if (
        this._donationFrequency.giftTerminationMonth !== null &&
        this._donationFrequency.giftTerminationYear !== null
      ) {
        this.transaction.monthToTerminate =
          this._donationFrequency.giftTerminationMonth;
        this.transaction.yearToTerminate =
          this._donationFrequency.giftTerminationYear;
      }
    }
    this.transaction.nonce = payload.nonce;
    this._toggleFrequencyLabel();
    this.handleOpenVerifyModal();
  }

  private _mapCreditCardType(cardType: string): CreditCardTypeEnum | null {
    const normalized = (cardType || "").toLowerCase().replace(/\s/g, "");

    switch (normalized) {
      case "americanexpress":
      case "amex":
        return CreditCardTypeEnum.Amex;
      case "discover":
        return CreditCardTypeEnum.Discover;
      case "mastercard":
        return CreditCardTypeEnum.Mastercard;
      case "visa":
        return CreditCardTypeEnum.Visa;
      default:
        return null;
    }
  }

  private _toggleFrequencyLabel() {
    this.frequency = this._common.getFrequencyText(
      this.transaction.chargeFrequency
    );
    switch (this.frequency) {
      case "One Time":
        this.frequency = this._language.translate("ONE_TIME");
        break;
      case "Monthly":
        this.frequency = this._language.translate("MONTHLY");
        break;
      case "Quarterly":
        this.frequency = this._language.translate("QUARTERLY");
        break;
      case "Semi Annual":
        this.frequency = this._language.translate("SEMI_ANNUAL");
        break;
      case "Yearly":
        this.frequency = this._language.translate("ANNUALLY");
        break;
    }
  }

  private _sendTransaction() {
    this.toggleSpinner(true);
    this._data.Donor.saveTransaction(this.transaction).subscribe(
      (result) => {
        this._onTransactionResult(
          result as IDonorTransactionBindingModel,
          "Credit Card"
        );
      },
      (error) => {
        this.toggleSpinner(false);
        this._logger.logError({
          message: `Could not save the credit card payment<br />${this._common.jsonMessage(
            error
          )}`,
        });
      }
    );
  }

  private _onTransactionResult(
    returnItem: IDonorTransactionBindingModel,
    purchaseLabel: string
  ): void {
    if (returnItem.resultCode !== 0) {
      this.csr.donationAmount = this.transaction.donationAmount;
      this.csr.chargeFrequency = this.transaction.chargeFrequency;
      this.csr.responseMsg = returnItem.responseMsg;
      this._revealPaymentOutcome(() => this.handleOpenFailedCCECheckModal());
      return;
    }

    this.csr.processRefNo = returnItem.processRefNo;
    this.csr.responseMsg = returnItem.responseMsg;
    this.csr.resultCode = returnItem.resultCode;
    this.csr.authCode = returnItem.authCode;
    this.csr.donationAmount = this.transaction.donationAmount;
    this.csr.chargeFrequency = this.transaction.chargeFrequency;

    this._gaPurchase(purchaseLabel);
    this._savePersonalStory(returnItem.donorId);

    const revealConfirmation = () =>
      this._revealPaymentOutcome(() =>
        this.handleOpenCreditCardECheckPaymentModal()
      );

    if (!this.notifySomeone && !this.inMemoryHonorOf) {
      revealConfirmation();
      return;
    }

    this._processGiftNOtifyAndHonor(
      returnItem.donorId,
      returnItem.donorTransactionId,
      revealConfirmation
    );
  }

  private _revealPaymentOutcome(openModal: () => void): void {
    openModal();
    this.toggleSpinner(false);
    setTimeout(() => {
      this.donateForm.resetForm();
      this.transactionComplete = true;
      this._common.donationProcessed(true);
    });
  }

  private _gaPurchase(transactionType: string) {
    this._googleAnalytics.standardEventEmitter("purchase", {
      currency: "USD",
      transaction_id: Math.random().toString(36).substring(2, 25),
      value: this.transaction.donationAmount,
      items: [
        {
          id: this.transaction.campaignId,
          category: transactionType,
          brand:
            this.transaction.chargeFrequency === 2 ? "Recurring" : "One Time",
          name: "Donation",
          quantity: 1,
          price: this.transaction.donationAmount,
        },
      ],
    });

    // send DRTV purchase events to Disruptive Advertising
    if (this.drtv()) {
      this._googleAnalytics.customEventParamsEmitter("conversion", {
        send_to: "AW-844820968/e34jCLmL2bIDEOjj65ID",
      });
    }
  }

  submitECheck() {
    this.transaction.donorId = this.csr.donorId;
    this.transaction.campaignId = this.csr.campaignId();
    this.transaction.hospitalId = this.csr.hospitalId();
    this.transaction.radioStationNameId = this.csr.radioStationId();
    this.transaction.phoneDonationYn = false;
    this.transaction.donationSourceId = 3;
    this.transaction.donorSeed = this.csr.donorSeed;
    this.transaction.donorReferenceNumber = this.csr.donorReferenceNumber;

    this.transaction.transactionType = TransactionTypeEnum.ECheck;

    if (this.transaction.chargeFrequency !== ChargeFrequencyEnum.OneTime) {
      this.transaction.dayToCharge = this._donationFrequency.dayOfMonth;
      if (
        this._donationFrequency.giftTerminationMonth !== null &&
        this._donationFrequency.giftTerminationYear !== null
      ) {
        this.transaction.monthToTerminate =
          this._donationFrequency.giftTerminationMonth;
        this.transaction.yearToTerminate =
          this._donationFrequency.giftTerminationYear;
      }
    }

    this._toggleFrequencyLabel();
    this.toggleSpinner(false);
    this.handleOpenVerifyeCheckPaymentModal();
  }

  continueWithCall(reloadPage: boolean): void {
    const campaignId = this.csr.campaignId();
    const hospitalId = this.csr.hospitalId();
    const radioStationId = this.csr.radioStationId();
    
    const hasValidId = (id: string | null | undefined) => !!id && id !== "0";
    
    let path = `/donor/y/${campaignId}`;
    
    if (hasValidId(hospitalId)) {
      path += `/${hospitalId}`;
    }
    
    if (hasValidId(radioStationId)) {
      path += `/${radioStationId}`;
    }

    if (this.drtv()) {
      path = `/helpkidstoday/${campaignId}`;
      if (hasValidId(hospitalId)) {
        path += `/${hospitalId}`;
      }
    }

    if (reloadPage) {
      this.router.navigate([path], { skipLocationChange: true }).then(() => {
        window.location.reload();
        window.scrollTo(0, 0);
      });
    } else {
      this.router.navigate([path], { skipLocationChange: true });
      const element = this.elementRef?.nativeElement?.closest(
        ".drtv-donate-section"
      );
      if (element)
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
    }
  }

  private _sendECheckTransaction() {
    if (!this._validateNoCreditCardFieldsForSubmit()) {
      return;
    }
    var stateAbbrev = this.donorEditCommon.states.filter((state) => {
      return state.label === this.donorEditCommon.donor.state;
    })[0]["abrev"];

    const donor = this.donorEditCommon.donor;
    const firstName = (donor.firstName || "").trim();
    const lastName = (donor.lastName || "").trim();
    const businessName = (donor.companyName || "").trim();
    const hasPersonalName = !!(firstName && lastName);

    const bankDetails: BankAccountDetails = {
      routingNumber: this.transaction.abaNumber.toString(),
      accountNumber: this.transaction.bankAccountNumber.toString(),
      accountType: this.transaction.isCheckingAccount
        ? BankAccountType.Checking
        : BankAccountType.Savings,
      billingAddress: {
        streetAddress: donor.address1,
        extendedAddress: donor.address2,
        locality: donor.city,
        region: stateAbbrev,
        postalCode: donor.postalCode,
      },
    } as BankAccountDetails;

    if (hasPersonalName) {
      bankDetails.ownershipType = BankOwnershipType.Personal;
      bankDetails.firstName = firstName;
      bankDetails.lastName = lastName;
    } else if (businessName) {
      bankDetails.ownershipType = BankOwnershipType.Business;
      bankDetails.businessName = businessName;
    } else {
      this.toggleSpinner(false);
      this._common.toast.warning(
        this._language.translate("VALIDATION_DONOR_NAME")
      );
      return;
    }

    this.toggleSpinner(true);
    this.paymentDetails
      .tokenizeBankAccount(
        bankDetails,
        this._language.translate("ECHECK_MANDATE")
      )
      .then(
        (tokenizedPayload) => {
          this.transaction.nonce = tokenizedPayload.nonce;
          this.transaction.bankAccountNumber = String(this.transaction.bankAccountNumber ?? "");
          this.transaction.abaNumber = String(this.transaction.abaNumber ?? "");
          this._data.Donor.saveTransaction(this.transaction).subscribe(
            (result) => {
              this._onTransactionResult(
                result as IDonorTransactionBindingModel,
                "eCheck"
              );
            },
            (error) => {
              this._logger.logError({
                message: `Could not save the eCheck payment<br />${this._common.jsonMessage(
                  error
                )}`,
              });
              this.toggleSpinner(false);
            }
          );
        },
        (tokenizeError) => {
          this.toggleSpinner();
          console.error(tokenizeError);
          this._common.toast.error(this._language.translate("BANK_DETAILS_ERROR"));
        }
      );
  }


  private _validateNoCreditCardFieldsForSubmit(): boolean {
    // Validate optional free-text fields (personal story + additional comments).
    // We only validate when the fields have content.
    let isValid = true;

    const storyText = this.personalStoryComponent?.personalStory?.trim();
    if (!storyText) {
      this.personalStoryValidationError = null;
    } else {
      const storyControl = new FormControl(storyText);
      const storyValidation = validateNoCreditCard(storyControl);
      if (storyValidation?.containsCreditCard) {
        this.personalStoryValidationError = "VALIDATION_STORY_CREDIT_CARD";
        isValid = false;
      } else {
        this.personalStoryValidationError = null;
      }
    }

    const commentText = this.donorEditCommon?.donor?.comment?.trim();
    if (!commentText) {
      this.additionalCommentsValidationError = null;
    } else {
      const commentControl = new FormControl(commentText);
      const commentValidation = validateNoCreditCard(commentControl);
      if (commentValidation?.containsCreditCard) {
        this.additionalCommentsValidationError = "VALIDATION_COMMENTS_CREDIT_CARD";
        isValid = false;
      } else {
        this.additionalCommentsValidationError = null;
      }
    } 

    return isValid;
  }

  private _savePersonalStory(donorId: number) {
    const storyText = this.personalStoryComponent?.personalStory?.trim();
    if (!storyText) {
      return;
    }

    const model: IPersonalStoryBidningModel = {
      personalStoryId: 0,
      campaignId: this.csr.campaignId(),
      firstName: this.donorEditCommon.donor.firstName,
      lastName: this.donorEditCommon.donor.lastName,
      companyName: this.donorEditCommon.donor.companyName || "",
      telephone1: this.donorEditCommon.donor.telephone || "",
      email: this.donorEditCommon.donor.email || "",
      briefDescription: storyText,
      donorId: donorId,
      personalStoryText: "",
      shareStoryStatusId: Enums.ShareStoryStatusEnum.DonorComment,
      dayOfWeek: null,
      radioStationNameId: null,      
      readYn: false,
      telephone2: null,
      timeOfDay: null,
      updateKey: 0,
      displayInDash: true,
    };

    this._data.Donor.savePersonalStory(model).subscribe({
      next: () => {
        this._logger.logSuccess({ message: "Personal story has been saved." });
      },
      error: (error) => {
        this._logger.logError({
          message: `Could not save the personal story.<br />${this._common.jsonMessage(error)}`,
        });
      },
    });
  }

  private _applyPlannedGivingToDonor(): void {
    const donor = this.donorEditCommon?.donor;
    if (!donor) {
      return;
    }

    donor.plannedGivingInterest = !!this.plannedGiving?.plannedGivingInterest;
    donor.plannedGivingPhone = this.plannedGiving?.plannedGivingPhone || "";
    donor.plannedGivingEmail = this.plannedGiving?.plannedGivingEmail || "";
  }

  private _processGiftNOtifyAndHonor(
    donorId: number,
    donorTransactionId: number,
    onDone: () => void
  ): void {
    const data = {} as IInHonorNotificationBindingModel;
    if (this.notifySomeone) {
      this.giftNotify.donorId = donorId;
      this.giftNotify.donorTransactionId = donorTransactionId;
      this.giftNotify.giftNotificationId = 0;
      data.giftNotificationModel = this.giftNotify;
      this.giftNotify.campaignId = this.csr.campaignId();
    }
    if (this.inMemoryHonorOf) {
      this.honorModel.inHonorOf = this.honorDetails.inHonor;
      this.honorModel.donorId = donorId;
      this.honorModel.donorTransactionId = donorTransactionId;
      data.inHonorModel = this.honorModel;
      this.honorModel.campaignId = this.csr.campaignId();
    }
    if (!data.inHonorModel && !data.giftNotificationModel) {
      onDone();
      return;
    }

    this._data.Donor.saveInHonorGiftNotification(data).subscribe({
      next: () => {
        if (data.inHonorModel && !data.giftNotificationModel) {
          this._logger.logSuccess({
            message: "'In Honor/Memory Of' data has been saved",
          });
        }
        if (!data.inHonorModel && data.giftNotificationModel) {
          this._logger.logSuccess({
            message: "Gift Notification has been saved.",
          });
        }
        if (data.inHonorModel && data.giftNotificationModel) {
          this._logger.logSuccess({
            message:
              "Gift Notification and 'In Honor/Memory Of' data has been saved.",
          });
        }
        onDone();
      },
      error: (error) => {
        this._logger.logError({
          message: `Could not save the Gift NOtification or In Honor/Memory Of.<br />${this._common.jsonMessage(
            error
          )}`,
        });
        onDone();
      },
    });
  }

  // reCAPTCHA
  resolved(captchaResponse: string): void {
    if (!this._waitingForRecaptcha) {
      return;
    }

    if (!captchaResponse?.trim()) {
      this.errored("No reCAPTCHA token was returned");
      return;
    }

    this._waitingForRecaptcha = false;
    this._saveDonor(captchaResponse);
  }

  errored(errorDetails: any) {
    if (!this._waitingForRecaptcha) {
      return;
    }

    this._waitingForRecaptcha = false;
    this.isVerifying = false;
    this.toggleSpinner(false);
    this._common.toast.error(this._language.translate("ERROR_RECAPTCHA"));
    console.warn(`reCAPTCHA error encountered: ${errorDetails}`);
  }

  trackModalEvent(actionType: string, label: string): void {
    this._googleAnalytics.customEventEmitter({
      eventName: `Splash_modal_${actionType}`,
      eventCategory: 'Modal',
      eventAction: actionType,
      eventLabel: label
    });
  }
}
